import { Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';

import { SedsDisplayType } from '../../../shared/types/seds-display.type';
import { SedsThemeColorOptionsType } from '../../../shared/types/seds-theme-color-options.type';

@Component({
    selector: 'seds-alert-core',
    templateUrl: './seds-alert-core.component.html',
    styleUrls: ['./seds-alert-core.component.scss'],
    standalone: false
})
export class SedsAlertCoreComponent {
  @ContentChild('content', { static: true }) content!: HTMLElement;
  @ContentChild('header') header!: HTMLElement;
  @Input() close = false;
  @Input() color: SedsThemeColorOptionsType = 'default';
  @Input() display: SedsDisplayType | 'inline' | 'block' = 'inline';
  @Output() hasClosed = new EventEmitter();

  public setIcon(color: string) {
    switch (color) {
      case 'success':
        return 'check_circle';
      case 'default':
        return 'info';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  }

  keyboardClose(event: KeyboardEvent) {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      this.hasClosed.emit();
    }
  }
}
